import React, { useCallback } from 'react';
import { useIntl } from 'react-intl';
import clsx from 'clsx';
import { TypedMemo } from '../../../common/types';
import { ClickableDiv } from '../../../common/views/ClickableDiv';
import { themePreview } from '../../themePreviews';
import styles from './SMLThemeSwatch.module.scss';

interface SMLThemeSwatchProps {
  option: string;
  checked: boolean;
  disabled: boolean;
  onClick: (option: string) => void;
}

const SMLThemeSwatchComponent: React.FC<SMLThemeSwatchProps> = ({ option, checked, disabled, onClick }) => {
  const intl = useIntl();
  const handleClick = useCallback(() => onClick(option), [onClick, option]);

  return (
    <ClickableDiv onClick={handleClick} disabled={disabled} className={clsx(styles.swatch, checked && styles.checked)}>
      <img
        className={styles.image}
        src={themePreview(option)}
        alt={intl.formatMessage(
          { id: 'app.forms.smartLink.themeSelectionPreview.image-alt', defaultMessage: 'Preview of Theme {theme}' },
          { theme: option }
        )}
      />
      <span className={styles.name}>{option}</span>
    </ClickableDiv>
  );
};

export const SMLThemeSwatch = TypedMemo(SMLThemeSwatchComponent);
